var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3525 5.25142L9.1338 0.438117C8.50087 -0.145608 7.50165 -0.14647 6.86779 0.438117L1.64903 5.25142C1.15879 5.70356 0.800781 6.51712 0.800781 7.18211V14.4021C0.800781 15.2844 1.52052 16 2.4009 16H7.21354V11.2323H8.80504V16H13.5981C14.4823 16 15.2007 15.2862 15.2007 14.4021V7.18211C15.2008 6.51697 14.8438 5.70446 14.3525 5.25142ZM13.5981 14.4H10.4051V9.63232H5.61356V14.4C3.47172 14.4006 2.40079 14.4013 2.40079 14.4021V7.18211C2.40079 6.96487 2.57127 6.57742 2.73379 6.42754L7.95255 1.61427C7.97321 1.59522 8.02845 1.59525 8.04904 1.61427L13.2678 6.42754C13.4311 6.57814 13.6008 6.96439 13.6008 7.18211C13.6005 11.994 13.5996 14.4 13.5981 14.4Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.82ebb3d53106c3454d0675f6ede5a55b.svg";
export { ForwardRef as ReactComponent };